import { render, staticRenderFns } from "./child-session-drawer.vue?vue&type=template&id=addb3360&scoped=true"
import script from "./child-session-drawer.vue?vue&type=script&lang=js"
export * from "./child-session-drawer.vue?vue&type=script&lang=js"
import style0 from "./child-session-drawer.vue?vue&type=style&index=0&id=addb3360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addb3360",
  null
  
)

export default component.exports